import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TColumn } from '../types/column.type';

export const CreateColumnValidationSchema = z.object({
  name: z
    .string({ required_error: 'Column name is required.' })
    .min(1, { message: 'Column name is required.' }),
  spaceId: z
    .string({ required_error: 'Space is required.' })
    .min(1, { message: 'Space is required.' }),
  columnIndex: z
    .string({ required_error: 'Column index is required.' })
    .min(1, { message: 'Column index is required.' }),
  color: z
    .string({ required_error: 'Color is required.' })
    .min(1, { message: 'Color is required.' }),
});

export type TCreateColumnValidation = z.infer<typeof CreateColumnValidationSchema>;
export type TCreateColumnPayload = TCreateColumnValidation;
export type TCreateColumnResponse = ApiResponse<TColumn>;

export const createColumn = async (payload: TCreateColumnPayload): Promise<TCreateColumnResponse> => {
  const url = '/space-column';
  return axiosInstance.post(url, payload);
};

/**
 * Use Create Column React-Query Hook
 */
type UseCreateColumnMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof createColumn, AxiosErrorCustom>;
};

/**
 * Use Create Column React-Query Hook
 */
export const useCreateColumnMutation = ({ mutationConfig }: UseCreateColumnMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: createColumn,
    ...restConfig,
  });
};
